import { LanguageKey } from '@multiplatform-apps/service-trips';

import en from '../locale/en_US.json';
import no from '../locale/nb_NO.json';
import sv from '../locale/sv_SE.json';

export const translations = {
  en,
  sv,
  no,
};

interface LanguageOption {
  value: LanguageKey;
  label: string;
  shortLabel: string;
}

export const languages: LanguageOption[] = [
  { value: 'en', label: 'English', shortLabel: 'EN' },
  { value: 'sv', label: 'Svenska', shortLabel: 'SV' },
  { value: 'no', label: 'Norsk', shortLabel: 'NO' },
];
